import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingButtons from '@/components/feature/FloatingButtons';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import WhyBucara from './components/WhyBucara';
import OurExperience from './components/OurExperience';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'About Us | Bucara Burger – Colombian Food Truck in Boise, Idaho';
  }, []);

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <main>
        <AboutHero />
        <BrandStory />
        <WhyBucara />
        <OurExperience />
        <AboutCTA />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
